export default __webpack_public_path__ + "static/media/img42.daba98cc.jpg";